module.exports = __webpack_public_path__ + "static/media/ad-linkedin.ea8cdcb4.png";